var map = {
	"./App": 58609,
	"./App.vue": 58609,
	"./assets/css/anim.scss": 98570,
	"./assets/css/common.scss": 90807,
	"./assets/css/global.scss": 23059,
	"./assets/css/popPrompt.scss": 50082,
	"./assets/css/reset.scss": 12841,
	"./assets/css/utils.scss": 55955,
	"./assets/css/vtip.css": 96714,
	"./assets/fonts/PANTON-BLACK.OTF": 44871,
	"./assets/fonts/POPPINS-MEDIUM.OTF": 75936,
	"./assets/fonts/Poppins-Regular.ttf": 27588,
	"./assets/fonts/Poppins-SemiBold.ttf": 98167,
	"./assets/fonts/font.css": 39399,
	"./assets/icons": 17258,
	"./assets/icons/": 17258,
	"./assets/icons/index": 17258,
	"./assets/icons/index.js": 17258,
	"./assets/icons/svg/icon-add.svg": 68869,
	"./assets/icons/svg/icon-copy.svg": 54171,
	"./assets/icons/svg/icon-history.svg": 85292,
	"./assets/icons/svg/icon-invite.svg": 49855,
	"./assets/icons/svg/icon-leaders.svg": 34296,
	"./assets/icons/svg/icon-main.svg": 53079,
	"./assets/icons/svg/icon-ok.svg": 35686,
	"./assets/icons/svg/icon-per.svg": 94701,
	"./assets/icons/svg/icon-refresh.svg": 82037,
	"./assets/icons/svg/icon-share.svg": 71820,
	"./assets/icons/svg/icon-tasks.svg": 48199,
	"./assets/icons/svg/icon-telegram.svg": 45810,
	"./assets/icons/svg/icon-time.svg": 94375,
	"./assets/images/buySpineItemBg1.png": 99267,
	"./assets/images/buySpineItemBg2-tag.png": 71666,
	"./assets/images/buySpineItemBg2.png": 23474,
	"./assets/images/buySpineItemBg3-tag.png": 37315,
	"./assets/images/buySpineItemBg3.png": 20463,
	"./assets/images/firend-head.jpg": 74611,
	"./assets/images/icon/icon-buyTicket.png": 71728,
	"./assets/images/icon/icon-coin.png": 31310,
	"./assets/images/icon/icon-correctPrediction.png": 82857,
	"./assets/images/icon/icon-deposit.png": 76266,
	"./assets/images/icon/icon-instantReward.png": 51058,
	"./assets/images/icon/icon-star.png": 71923,
	"./assets/images/icon/icon-taskCompleted.png": 99016,
	"./assets/images/icon/icon-wrongPrediction.png": 6207,
	"./assets/images/icon/pop-invitationReward.png": 25560,
	"./assets/images/leaders-head.png": 87050,
	"./assets/images/loading-bg.jpg": 29093,
	"./assets/images/m1.jpg": 99732,
	"./assets/images/m2.jpg": 17800,
	"./assets/images/m3.jpg": 9612,
	"./assets/images/no-img.png": 25703,
	"./assets/images/pop-earn-ticket-img.png": 19995,
	"./assets/images/task-head.jpg": 85474,
	"./assets/images/yes-img.png": 26080,
	"./assets/images/youtube.png": 52674,
	"./assets/js/confetti": 19342,
	"./assets/js/confetti.js": 19342,
	"./assets/js/eventBus": 1093,
	"./assets/js/eventBus.js": 1093,
	"./assets/js/fireworkEffect": 83034,
	"./assets/js/fireworkEffect.js": 83034,
	"./assets/js/noZoom": 62654,
	"./assets/js/noZoom.js": 62654,
	"./assets/js/pop": 42487,
	"./assets/js/pop.js": 42487,
	"./assets/js/rem": 79633,
	"./assets/js/rem.js": 79633,
	"./assets/js/requestApiCache": 91270,
	"./assets/js/requestApiCache.js": 91270,
	"./assets/js/svg": 23367,
	"./assets/js/svg.js": 23367,
	"./components/layout": 23711,
	"./components/layout.vue": 23711,
	"./components/mCoinAnim": 5769,
	"./components/mCoinAnim.vue": 5769,
	"./components/mCountUp": 51,
	"./components/mCountUp.vue": 51,
	"./components/mEmpty": 69967,
	"./components/mEmpty.vue": 69967,
	"./components/mHead": 51264,
	"./components/mHead.vue": 51264,
	"./components/mHeadImg": 82507,
	"./components/mHeadImg.vue": 82507,
	"./components/mLoading": 16785,
	"./components/mLoading.vue": 16785,
	"./components/mMenu": 87630,
	"./components/mMenu.vue": 87630,
	"./components/mPage": 8673,
	"./components/mPage.vue": 8673,
	"./components/mSlide": 67059,
	"./components/mSlide.vue": 67059,
	"./components/mTab": 23097,
	"./components/mTab.vue": 23097,
	"./components/popPrompt": 12039,
	"./components/popPrompt.vue": 12039,
	"./components/popUpgrade": 1146,
	"./components/popUpgrade.vue": 1146,
	"./components/svgIcon": 37115,
	"./components/svgIcon.vue": 37115,
	"./directive": 90973,
	"./directive/": 90973,
	"./directive/direct/v-anchor": 52828,
	"./directive/direct/v-anchor.js": 52828,
	"./directive/direct/v-copy": 44404,
	"./directive/direct/v-copy.js": 44404,
	"./directive/direct/v-debounce": 64459,
	"./directive/direct/v-debounce.js": 64459,
	"./directive/direct/v-draggable": 52971,
	"./directive/direct/v-draggable.js": 52971,
	"./directive/direct/v-scroll": 57660,
	"./directive/direct/v-scroll.js": 57660,
	"./directive/direct/v-shuibowen": 73131,
	"./directive/direct/v-shuibowen.js": 73131,
	"./directive/index": 90973,
	"./directive/index.js": 90973,
	"./http": 11063,
	"./http/": 11063,
	"./http/index": 11063,
	"./http/index.js": 11063,
	"./i18n": 86926,
	"./i18n/": 86926,
	"./i18n/i18nOption": 17292,
	"./i18n/i18nOption.json": 17292,
	"./i18n/index": 86926,
	"./i18n/index.js": 86926,
	"./i18n/json/Chs": 15077,
	"./i18n/json/Chs.json": 15077,
	"./i18n/json/En": 74030,
	"./i18n/json/En.json": 74030,
	"./main": 43217,
	"./main.js": 43217,
	"./mixins/anim": 82568,
	"./mixins/anim.js": 82568,
	"./mixins/taskMixins": 25868,
	"./mixins/taskMixins.js": 25868,
	"./router": 15092,
	"./router/": 15092,
	"./router/index": 15092,
	"./router/index.js": 15092,
	"./store": 68854,
	"./store/": 68854,
	"./store/index": 68854,
	"./store/index.js": 68854,
	"./store/modules/facescan": 22241,
	"./store/modules/facescan.js": 22241,
	"./store/modules/game": 52983,
	"./store/modules/game.js": 52983,
	"./store/modules/task": 72390,
	"./store/modules/task.js": 72390,
	"./store/modules/user": 69220,
	"./store/modules/user.js": 69220,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet.js": 9944,
	"./tonWallet": 88929,
	"./tonWallet/": 88929,
	"./tonWallet/config/config": 73649,
	"./tonWallet/config/config.json": 73649,
	"./tonWallet/config_for_test/config": 46398,
	"./tonWallet/config_for_test/config.json": 46398,
	"./tonWallet/index": 88929,
	"./tonWallet/index.js": 88929,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/errcode": 48956,
	"./utils/errcode.js": 48956,
	"./utils/formatter": 83291,
	"./utils/formatter.js": 83291,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./view": 4901,
	"./view/": 4901,
	"./view/adm": 22266,
	"./view/adm.vue": 22266,
	"./view/history": 52194,
	"./view/history.vue": 52194,
	"./view/index": 4901,
	"./view/index.vue": 4901,
	"./view/invite": 9179,
	"./view/invite.vue": 9179,
	"./view/leaders": 51128,
	"./view/leaders.vue": 51128,
	"./view/tasks": 80180,
	"./view/tasks.vue": 80180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;